import { Injectable } from '@angular/core';

import { ModalController, NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { CreatePasswordPage } from '../create-password/create-password.page';
import { AuthService } from './auth.service';



@Injectable()
export class LoginGuard  {
  constructor(private authService: AuthService, private navCtrl: NavController, private modalCtrl: ModalController) { }

  canActivate(): Observable<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      if (this.authService.isNewAccount()) {
        this.modalCtrl.create({
        component: CreatePasswordPage,
          swipeToClose: false,
          keyboardClose: false,
          backdropDismiss: false,
        }).then(modal => {
          modal.present();
        })
      }
      this.navCtrl.navigateRoot(['/main/products']);
      return;
    }
    return true
  }
}